export default "__VITE_ASSET__Djjrj3Fl__"